import * as React from 'react';
import Checkbox from '@mui/material/Checkbox';
import FormLabel from '@mui/material/FormLabel';
import InputLabel from '@mui/material/InputLabel';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';

export const Checkboxes = ({
  id,
  value,
  updateValue,
  path,
  items,
  label,
  description,
  limit,
  errors,
  visible,
}) => {

  const [selectedValue, setSelectedValue] = React.useState({})
  // const selectedValue = React.useMemo(() => {
  //   let selected = {}
  //   if (value?.length > 0) {
  //     for(let val of value) {
  //       selected[val] = true
  //     }
  //   }
  //   console.log('selected', selected)
  //   return selected
  // }, [value])

  React.useEffect(() => {
    let selected = {}
    if (items?.enum?.length > 0) {
      for(let val of items?.enum) {
        selected[val] = value?.includes(val) ?? false
      }
    }
    // console.log('selected', selected)
    setSelectedValue(selected)
  }, [value, items])

  const buttonStyle ={
    float: 'right',
    marginLeft: '1em',
  }

  const handleChange = (event) => {
    let newValue = event.target.value
    let newValues = value ?? []
    if (!newValues.includes(newValue)) {
      newValues.push(newValue)
    } else {
      newValues.splice(newValues.indexOf(newValue), 1)
    }
    // console.log('newValues', newValues)
    let selected = { ...selectedValue }
    selected[newValue] = !selected[newValue]
    // console.log('selected handleChange', selected)
    setSelectedValue(selected)
    updateValue(newValues)
  };

  return (
    <div id={`#/properties/${path}`} className={path} style={{ display: visible ? 'block' : 'none' }}>
      <InputLabel style={{ marginTop: '0.8em' }}>{label}</InputLabel>
      <InputLabel style={{ marginTop: '0.8em' }}>{description}</InputLabel>
      { errors &&
        <FormHelperText error={true} filled={true}>{errors}</FormHelperText>
      }
      <Grid
        container
        spacing={{ xs: 0.5, md: 1 }}
        columns={{ xs: 4, sm: 8, md: 12 }}
        justify="flex-end"
        alignItems="center"
      >
        {Object.keys(selectedValue)?.length > 0 && items?.enum?.map((item, idx) => {
          return (
            <Grid item xs={2} sm={4} md={4} key={`Grid-${idx}`}>
              <FormControlLabel control={
                <Checkbox
                  checked={selectedValue[item]}
                  onChange={handleChange}
                  value={item}
                  name={`radio-buttons-${item}`}
                  inputProps={{ 'aria-label': item }}
                />
              } label={item} />
            </Grid>
          )
        })}
      </Grid>
    </div>
  );
};
